import React, { memo } from 'react';

import { Box } from '@mui/material';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { HORIZONTAL_ALIGNMENT } from 'constants/ui';

const ButtonGroupWrapper = ({
  children,
  alignment = HORIZONTAL_ALIGNMENT.LEFT,
  className,
  ...props
}) => {
  const classes = clsx(
    'flex gap-8',
    {
      'justify-start': alignment === HORIZONTAL_ALIGNMENT.LEFT,
      'justify-center': alignment === HORIZONTAL_ALIGNMENT.CENTER,
      'justify-end': alignment === HORIZONTAL_ALIGNMENT.RIGHT,
    },
    className,
  );

  return (
    <Box className={classes} {...props}>
      {children}
    </Box>
  );
};

ButtonGroupWrapper.propTypes = {
  alignment: PropTypes.oneOf(Object.values(HORIZONTAL_ALIGNMENT)),
  className: PropTypes.string,
};

export default memo(ButtonGroupWrapper);
